<script>
  import HeroOverlay from '../components/HeroOverlay.svelte';
</script>

<a id="home" href="#home">&nbsp;</a>
<HeroOverlay />
